<template><div>

	<!-- блок с локальным сообщением об ошибке -->
	<transition name="fadeControl" key="transitionError">
		<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
			<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
			<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
		</div>
	</transition>

	<!-- Instruction -->
	<div v-if="templateInstruction && templateInstruction.value && false" class="tab-pane-command-wrapper">
		<!-- <h4>{{ templateInstruction.title | ftc }}</h4> -->
		<pre class="w5-normal-pre" v-withSafeTags="localeFtc(linkifyText(templateInstruction.value))"></pre>
	</div>

	<!-- блок перезагрузки -->
	<div class="tab-pane-command-wrapper">
		<h4>{{ 'service/reboot_button_header' | ftc }}</h4>
		<p v-withSafeTags="localeFtc('service/reboot_button_description')"></p>
		<!-- перезагрузка -->
		<div class="btn btn-submit tab-command-button" :class="{ 'disable': !Access || Status !== 'active' || !Reboot }" @click="reboot">
			<font-awesome-icon icon="power-off" class="hidden-xs" />
			{{ 'service/reboot' | ftc }}
		</div>
	</div>

	<!-- блок ISO -->
	<div class="tab-pane-command-wrapper">
		<h4>{{ 'service/iso_button_header' | ftc }}</h4>
		<p v-withSafeTags="localeFtc('service/iso_button_description')"></p>
		<div class="btn btn-submit tab-command-button" :class="{ 'disable': !Access || Status !== 'active' || isISOProcessActive }" @click="operIso">
			<font-awesome-icon icon="compact-disc" class="hidden-xs" />
			<span v-if="ISO && ISO.length">{{ 'service/iso' | ftc }}</span>
			<span v-else>{{ 'service/iso_insert' | ftc }}</span>
		</div>

		<!-- список образов -->
		<div v-if="iso && iso.length" style="margin-top: 20px; line-height: 1.2;">
			<!-- заголовок -->
			<span>{{ iso[0] && iso[0]['service_name'] && iso[0]['service_name']['title'] ? iso[0]['service_name']['title'] : 'service/iso' | ftc }}:</span>
			<!-- каждый образ -->
			<span v-for="(_iso, _idx) in iso" :key="_iso && _iso.service_id && _iso.service_id.value ? _iso.service_id.value : _idx">
				<span v-if="_idx > 0">, &nbsp;</span>
				<span v-if="_iso && _iso['service_status'] && _iso['service_status']['text']" style="color: green">
					<span v-if="_iso && _iso['service_name'] && _iso['service_name']['value']" style="color: #333">{{ _iso['service_name']['value'] }}&nbsp;</span>
					<img src="../../assets/img/loading16.gif" /> {{ _iso['service_status']['text'] | ftc | lower }}
				</span>
				<span v-else-if="_iso && _iso['service_status'] && _iso['service_status']['value'] && _iso['service_status']['value'] !== 'active'" :class="'w5-status-color-' + _iso['service_status']['value']">
					<template v-if="_iso['service_status']['list'] && _iso['service_status']['list'][_iso['service_status']['value']]">{{ _iso['service_status']['list'][_iso['service_status']['value']] | ftc | lower }}</template>
					<template v-else>{{ _iso['service_status']['value'] | ftc | lower }}</template>
				</span>
				<linkComponent v-else :url="'/service/view/' + _iso['service_id']['value']" :text="_iso['service_name']['value']" />
			</span>
		</div>
	</div>

	<!-- продление -->
	<div v-if="canProlong" class="tab-pane-command-wrapper">		
		<h4>{{ 'service/prolong_button_header' | ftc }}</h4>
		<p v-withSafeTags="localeFtc('service/prolong_button_description')"></p>
		<div class="btn btn-submit tab-command-button" @click="prolongVds">
			<font-awesome-icon icon="play-circle" class="hidden-xs" />
			{{ 'service/prolong' | ftc }}
		</div>
	</div>

	<!-- автопролонгация -->
	<div class="tab-pane-command-wrapper">
		<div class="control-wrapper">
			<input type="checkbox" class="w5-checkbox-field" v-model="autoProlongValue" style="display: none" />
			<label @click="autoProlongClick" :class="{ 'disable': !Access || Status !== 'active' || autoProlongProcessing }" style="display: inline-block; height: 3em; line-height: 3em;">
				{{ 'service/autoprolong' | ftc }}
			</label>
		</div>
		<span class="warning-message" v-withSafeTags="localeFtc('service/autoprolong_off')"></span>
	</div>

	<!-- кнопка удаления -->
	<div v-if="canDelete" class="tab-pane-command-wrapper">
		<div class="del-button-wrapper">
			<div class="control-wrapper">
				<div class="btn btn-submit-danger tab-command-button" :class="{ 'disable': !Access || Status !== 'active' }" @click="deleteVds">
					<font-awesome-icon icon="trash-alt" class="hidden-xs" />
					{{ 'service/delete_vds' | ftc }}
				</div>
			</div>
			<br>
			<span class="warning-message"><strong>{{ 'main/attention' | ftc }}!</strong> {{ 'service/vds_delete_warning' | ftc }}!</span>
		</div>
	</div>




	<!-- диалог перезагрузки -->
	<transition name="modal">
		<div v-show="showRebootModal" @click="hideRebootModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>

					<!-- заголовок -->
					<div class="modal-header">
						<span class="font-weight-500">{{ 'service/reboot' | ftc }}</span>
						<button type="button" class="close" @click="hideRebootModal">&times;</button>
					</div>

					<!-- тело диалога -->
					<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(rebootModalText)"></p></div>

					<!-- поле - жесткая перегрузка -->
					<div class="modal-body">
						<input type="checkbox" class="w5-checkbox-field" v-model="rebootHardValue" />
						<label @click="rebootHardClick" style="display: inline-block; height: 3em; line-height: 3em;">
							{{ 'service/reboot_hard' | ftc }}
						</label>
					</div>

					<!-- подвал -->
					<div class="modal-footer">
						<span class="btn btn-submit pull-right" @click="rebootStart">{{ 'service/reboot' | ftc }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>




	<!-- диалог изменения пароля -->
	<transition name="modal">
		<div v-show="showPasswordModal" @click="hidePasswordModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>

					<!-- заголовок -->
					<div class="modal-header">
						<button type="button" class="close" @click="hidePasswordModal">&times;</button>
						<span class="font-weight-500">{{ 'service/password_change' | ftc }}</span>
						<br>
						<span class="font-weight-300 font-size-85 color-black">{{ rebootWarning | ftc }}</span>
					</div>

					<!-- тело диалога -->
					<div class="modal-body">
						<div v-if="passwordWarning" class="w5-form-row">
							<div class="alert alert-warning font-size-90 margin-0 full-width" v-withSafeTags="passwordWarning"></div>
						</div>

						<div class="w5-form-row">
							<Field
								:isVisibleRow="true"
								crud="vds"
								action="view"
								v-model="passwordValue"
								:Field="passwordField"
								:removeRightPadding="true"
								:fieldInModal="true"
								@focus="onFocusPassword"
								@enterKeyDown="passwordChange" />
						</div>
					</div>

					<!-- подвал -->
					<div class="modal-footer">
						<span class="btn btn-submit pull-right" @click="passwordChange">{{ 'service/password_change' | ftc }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>




	<!-- диалог удаления записи -->
	<transition name="modal">
		<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>
					<!-- заголовок -->
					<div class="modal-header">
						<span class="font-weight-500">{{ 'main/delete' | ftc }}</span>
						<button type="button" class="close" @click="hideDeleteModal">&times;</button>
					</div>

					<!-- тело диалога -->
					<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p></div>

					<!-- подвал -->
					<div class="modal-footer" :class="{ 'flbx': Access && Status === 'active', 'r': reserveIpLocalData && Access && Status === 'active' }">
						<!-- резервирование IP -->
						<div v-if="reserveIpLocalData && Access && Status === 'active'" class="tab-pane-command-wrapper" style="margin: 0 0 15px; padding: 5px 10px 10px 10px; text-align: initial">
							<div class="control-wrapper">
								<input type="checkbox" class="w5-checkbox-field" v-model="reserveIpValue" style="display: none" />
								<label @click="reserveIpStart" :class="{ 'disable': !Access || Status !== 'active' || reserveIpProcessing || (deleteModalTimer && deleteModalTimer > 0) }" style="display: inline-block; height: 3em; line-height: 3em;">
									{{ 'main/save ippool/ippool' | ftc }}
								</label>
								<div class="warning-message" v-withSafeTags="localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)" style="margin-bottom: 0; font-size: 90%"></div>
							</div>
						</div>
						<div v-if="!reserveIpLocalData && Access && Status === 'active'">
							<img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" />
						</div>

						<!-- кнопка -->
						<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteStart">{{ modalDeleteButtonTitle }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>



	<!-- диалог подтверждения -->
	<transition name="modal">
		<div v-show="showConfirmModal" @click="hideConfirmModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>
					<!-- заголовок -->
					<div class="modal-header">
						<span class="font-weight-500">{{ confirmModalTitle | ftc }}</span>
						<button type="button" class="close" @click="hideConfirmModal">&times;</button>
					</div>

					<!-- тело диалога -->
					<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(confirmModalText)"></p></div>

					<!-- подвал -->
					<div class="modal-footer">
						<span class="btn btn-submit btn-submit-danger pull-right" :disabled="confirmModalTimer && confirmModalTimer > 0 ? 'disabled' : false" @click="confirmStart">{{ modalConfirmButtonTitle }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>



	<!-- диалог атача/детача ISO -->
	<transition name="modal">
		<div v-show="showOperISOModal" @click="hideOperISOModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>

					<!-- заголовок -->
					<div class="modal-header">
						<span class="font-weight-500">{{ 'service/iso' | ftc }}</span>
						<button type="button" class="close" @click="hideOperISOModal">&times;</button>
					</div>

					<!-- тело диалога -->
					<div class="modal-body">						
						<template class="w5-form-row">
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="isoValue1"
									:Field="isoField1"
									:removeRightPadding="true"
									:fieldInModal="true"
									:listBlockToOut="1"
									@focus="onFocusIso"
									@enterKeyDown="operIsoBegin" />
							</div>

							<div v-show="(ISO && ISO.length) || (isoValue1 !== null && isoValue1 > 0)" class="w5-form-row">
								<Field
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="isoValue2"
									:Field="isoField2"
									:removeRightPadding="true"
									:listBlockToOut="1"
									@focus="onFocusIso"
									@enterKeyDown="operIsoBegin" />
							</div>
						</template>

						<p class="padding-0-5" v-if="operisoModalText" v-withSafeTags="localeFtc(operisoModalText)"></p>
					</div>

					<!-- подвал -->
					<div class="modal-footer">
						<urlButtonComponent crud="vds" name="create_iso" :url="'/iso/create'" :text="'service/iso_create'" class="pull-left" />
						<span class="btn btn-submit pull-right" :class="{ 'btn-submit-danger': operisoModalButton === 'main/detach' }" @click="operIsoBegin">{{ operisoModalButton | ftc }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>




</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import urlButtonComponent from '@/components/elements/urlbtn'
import linkifyHtml from 'linkifyjs/html'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabCommand',
	//=========================================================================
	// данные переданные родителем
	//=========================================================================
	props: [
		'vdsId',
		'access',
		'status',
		'serviceStatus',
		'canReboot',
		'serviceName',
		'serviceFullName',
		'templateName',
		'templateInstruction',
		'iso',
		'active',
		'serviceProlong',
		'serviceCanProlong',
		'serviceCanDelete',
		'parentError',
		'reserveIpData'
	],
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// кнопка на модальном диалоге удаления
		modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete')
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)
		},
		// кнопка на модальном диалоге подтверждения
		modalConfirmButtonTitle() {
			if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc(this.modalConfirmButtonTitleText)
			return this.confirmModalTimer + ' - ' + this.localeFtc(this.modalConfirmButtonTitleText)
		},
		// есть ли активный процесс ISO
		isISOProcessActive() {
			if (!this.ISO || !this.ISO.length) return false

			return this.ISO.some(iso => {
				if (iso && iso['service_status'] && iso['service_status']['text']) {
					return true
				}
			})
		},
		reserveIpCost() {
			if (!this.reserveIpData || !('cost' in this.reserveIpData)) return ''
			if (this.reserveIpData['cost'] <= 0) return ''

			return this.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>')
				.replace('{cost}', this.reserveIpData['cost'])
				.replace('{period}', this.localeFtc(this.reserveIpData['period']))
				.replace('{for}', this.localeFtc(this.reserveIpData['for']))
		}
	},
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			Access: false,
			Status: null,
			Reboot: false,
			Template: '',
			fullName: '',
			ISO: null,
			validOsAndIso: false,
			Error: '',

			localErrorMessage: '',

			showRebootModal: false,
			rebootModalText: '',
			rebootHardValue: false,

			autoProlongValue: false,
			autoProlongProcessing: false,

			// резервирование IP
			reserveIpLocalData: null,
			reserveIpValue: false,
			reserveIpProcessing: false,

			canDelete: true,

			canProlong: false,
			canProlongProcessing: false,

			showPasswordModal: false,
			passwordWarning: '',
			rebootWarning: '',
			passwordValue: '',
			passwordField: {
				'required': true,
				'type': 'password',
				'title': 'main/new_password',
				'_field_name': 'newPassword',
				'_visible': true,
				'generator': true,
				'_errMsg': ''
			},

			// диалог удаления
			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,

			// диалог подтверждения
			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalText: '',
			modalConfirmButtonTitleText: '',
			confirmStart() {},
			confirmModalTimer: false,
			confirmModalTimerHandle: false,

			// диалог операций над ISO
			showOperISOModal: false,
			operisoModalText: '',
			operisoModalButton: '',
			isoValue1: null,
			isoField1: {
				required: true,
				type: 'list',
				list: [],
				title: 'service/iso',
				_field_name: 'iso_id1',
				_visible: true,
				_errMsg: ''
			},
			isoValue2: null,
			isoField2: {
				required: true,
				type: 'list',
				list: [],
				title: 'service/iso',
				readonly: false,
				_field_name: 'iso_id2',
				_visible: true,
				_errMsg: ''
			},
			// для запоминания ID ISO и проверке в пушах
			isoIdForPush1: null,
			isoIdForPush2: null,
			// старые значения формы
			isoOldValues: {}
		}
	},
	//=========================================================================
	// создание компонента
	//=========================================================================
	created() {
		this.Access = this.access
		this.Status = this.status
		this.Reboot = this.canReboot
		this.Template = this.templateName
		this.fullName = this.serviceFullName
		this.ISO = this.iso
		this.autoProlongValue = this.serviceProlong
		this.canProlong = this.serviceCanProlong
		this.canDelete = this.serviceCanDelete
		this.Error = this.parentError

		// если название шаблона не содержит "windows" и "freebsd" - добавим предупреждение о перезагрузке
		// if (this.Template.toLowerCase().indexOf('windows') < 0 && this.Template.toLowerCase().indexOf('freebsd') < 0)
		// теперь это нужно показывать в любом случае
		this.passwordWarning = this.localeFtc('service/reboot_warning')

		// описание смены пароля
		this.rebootWarning = 'service/change_password_for_vnc'
		// для линуксов еще и пароль рута
		if (this.Template.toLowerCase().indexOf('centos') >= 0 ||
			this.Template.toLowerCase().indexOf('ubuntu') >= 0 ||
			this.Template.toLowerCase().indexOf('debian') >= 0)
			this.rebootWarning = 'service/change_password_for_vnc_linux'

		// если операционка "windows" или "freebsd" или вставлен "ISO" - отключаем кнопку смены пароля
		if (this.Template.toLowerCase().indexOf('windows') > -1 ||
			this.Template.toLowerCase().indexOf('freebsd') > -1 ||
			this.ISO)
			this.validOsAndIso = false
		else
			this.validOsAndIso = true

		// копируем данные reserve_ip в локальное значение
		this.reserveIpLocalData = this.reserveIpData
		// текущее значение для резервирования IP
		this.reserveIpValue = this.reserveIpData && 'value' in this.reserveIpData
			? this.reserveIpData.value
			: false

		// если есть команда перехода
		if (this.$store.state.vdsCommand &&
			String(this.$store.state.vdsCommand['id']) === String(this.vdsId) &&
			this.$store.state.vdsCommand['command'] === 'reboot')
		{
			// покажем диалог перезагрузки
			this.$nextTick(() => this.reboot())
			// обнулим команду
			this.$store.commit('setVdsCommand', false)
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)

		if (this.deleteModalTimerHandle)
		{
			clearInterval(this.deleteModalTimerHandle)
			this.deleteModalTimerHandle = false
		}

		if (this.confirmModalTimerHandle)
		{
			clearInterval(this.confirmModalTimerHandle)
			this.confirmModalTimerHandle = false
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов
			if (e.keyCode === 27 && this.active)
			{
				e.preventDefault()

				this.hideRebootModal()
				this.hidePasswordModal()
				this.hideDeleteModal()
				this.hideConfirmModal()
			}
		},
		//---------------------------------------------------------------------
		// форматирование текста с ссылками
		//---------------------------------------------------------------------
		linkifyText(text) {
			return linkifyHtml(text, {
				defaultProtocol: 'https',
				validate: {
					url: (value) => {
						return /^(http|ftp)s?:\/\//.test(value)
					}
				}
			})
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return
			// вкладка не активна
			if (!this.active) return

			// не задан ID ISO
			if (!this.isoIdForPush1 && !this.isoIdForPush2) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== 'service') return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// может быть это ID нашего VDS?
			let _isVds = String(this.vdsId) === String(_id)
			// ищем запись с таким ID в строкe для рендеринга
			let _foundIso = String(this.isoIdForPush1) === String(_id) || String(this.isoIdForPush2) === String(_id)

			// если это был ID нашего VDS или снимка - рефрешим данные
			if (_isVds || _foundIso) this.$emit('requestData')
		},
		//---------------------------------------------------------------------
		// автопролонгация
		//---------------------------------------------------------------------
		// диалог подтверждения
		autoProlongClick() {
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если мы в процессе изменения - ничего не делаем
			if (this.autoProlongProcessing) return

			// если включают (было отключено)
			if (!this.autoProlongValue)
			{
				// можно сразу - без диалога
				this.confirmModalTimer = 0
				this.autoProlongStart()
				return
			}

			// настраиваем диалог подтверждения
			this.confirmModalTitle = 'service/autoprolong'
			this.confirmModalText = this.localeFtc('service/autoprolong_off')
			this.modalConfirmButtonTitleText = 'main/detach'
			this.confirmStart = this.autoProlongStart

			// таймер
			this.confirmModalTimer = 5
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModal = true
			// запускаем таймер
			this.confirmModalTimerHandle = setInterval(() => {
				this.confirmModalTimer--
				if (this.confirmModalTimer <= 0)
				{
					clearInterval(this.confirmModalTimerHandle)
					this.confirmModalTimerHandle = false
				}
			}, 1000)
		},
		// старт процесса
		autoProlongStart() {
			// если еще активен таймер
			if (this.confirmModalTimer && this.confirmModalTimer > 0) return

			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если мы в процессе изменения - ничего не делаем
			if (this.autoProlongProcessing) return

			// ставим флаг начала процесса
			this.autoProlongProcessing = true
			// закрываем диалог
			this.hideConfirmModal()
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'autoprolong': !this.autoProlongValue ? 1 : 0
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.autoProlongProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.autoProlongValue = !this.autoProlongValue
									// на это всем, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.$emit('successMessage', 'main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.autoProlongProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.autoProlongProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.autoProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// продление
		//---------------------------------------------------------------------
		prolongVds() {
			// проверка параметра
			if (!this.vdsId) return
			// если нельзя пролонгировать
			if (!this.canProlong) return
			// если мы в процессе изменения - ничего не делаем
			if (this.canProlongProcessing) return

			// ставим флаг начала процесса
			this.canProlongProcessing = true

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=setProlong'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг
								this.canProlongProcessing = false
								// проверяем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// рефрешим данные
									this.$emit('requestData')
									// на этом все
									return
								}

								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг
								this.canProlongProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг
					this.canProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг
					this.canProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// перезагрузка
		//---------------------------------------------------------------------
		// клик по кнопке в панеле (вызов диалога)
		reboot() {
			if (!this.Access || this.Status !== 'active' || !this.Reboot || this.Error) return
			this.localErrorMessage = ''
			this.rebootHardValue = false
			// текст для диалога перегрузки
			this.rebootModalText = this.localeFtc('service/reboot_vds_confirm').replace('{name}', '<b>' + this.serviceName + '</b>')
			EventBus.$emit('w5-body-scroll-disable')
			this.showRebootModal = true
		},
		// закрытие диалога
		hideRebootModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRebootModal = false
			this.hideModalMask()
		},
		// клик по галочке
		rebootHardClick() {
			this.rebootHardValue = !this.rebootHardValue
		},
		// старт ребута
		rebootStart() {
			// еще раз проверим доступ
			if (!this.Access || this.Status !== 'active' || !this.Reboot || this.Error) return
			// закроем диалог
			this.localErrorMessage = ''
			this.hideRebootModal()
			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=setReboot'
			if (this.rebootHardValue) _url += '&type=hard'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на это всем, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.$emit('successMessage', 'service/reboot_queued')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// VNC
		//---------------------------------------------------------------------
		// клик по кнопке в панеле
		vnc(e) {
			// проверка
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// обнуляем сообщения
			this.localErrorMessage = ''
			// если не заданы ID и название - ничего не делаем
			if (!this.vdsId || !this.serviceFullName)
			{
				this.localErrorMessage = 'VNC: service/not_found'
				return
			}

			// ID опеределен - открываем новое окно
			let _this = this
			window.getW5 = function() {
				// готовим функцию для дочернего окна
				return {
					getData: function(_Success, _Error) {
						// запрос VNC-данных
						_this.$http.get(_this.APIServerUrl + '/service/vnc/' + _this.vdsId).then(
							// если данные успешно получены
							resGet => {
								let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
								// получили требуемые данные
								if (_dt && _dt['status'] === 'ok' && _dt['vnc'] &&
									_dt['vnc']['host'] && _dt['vnc']['port'] && _dt['vnc']['password'])
								{
									_Success(_dt['vnc']['host'], _dt['vnc']['port'], _dt['vnc']['password'], _this.serviceFullName)
									return true
								}

								// получили ошибку
								if (_dt && _dt['status'] === 'error')
								{
									// сообщение по умолчанию
									let _err = 'VNC: ' + _this.localeFtc('main/no_data')
									// если есть "title"
									if ('title' in _dt) _err = _this.localeFtc(_dt['title'])
									// если есть "content"
									if ('content' in _dt) _err = _this.localeFtc(_dt['content'])

									_Error(_err)
									return false
								}

								// получили что то не то...
								_Error('VNC: ' + _this.localeFtc('main/no_data'))
								return false
							},
							// не удалось получить данные или сервер вернул ошибку
							resGet => {
								let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
								// сообщение по умолчанию
								let _err = 'VNC: ' + _this.localeFtc('main/no_data')
								// если есть "title"
								if (_dt && 'title' in _dt) _err = _this.localeFtc(_dt['title'])
								// если есть "content"
								if (_dt && 'content' in _dt) _err = _this.localeFtc(_dt['content'])

								_Error(_err)
								return false
							}
						) // get
					} // getData
				} // return
			} // window.getW5

			// открываем вкладку
			if (e.shiftKey)
			{
				// если зажат SHIFT - то с функциями
				window.open('/static/novnc/vnc.html?2', '_blank')
			}
			else
			{
				// иначе - во вкладке
				window.open('/static/novnc/start.html?2', '_blank')
			}
		},
		//---------------------------------------------------------------------
		// смена пароля
		//---------------------------------------------------------------------
		// клик по кнопке в панеле (вызов диалога)
		changePassword() {
			if (!this.Access || this.Status !== 'active') return
			if (this.Error) return
			this.localErrorMessage = ''
			this.passwordValue = ''
			this.passwordField['_errMsg'] = ''
			EventBus.$emit('w5-body-scroll-disable')
			this.showPasswordModal = true
		},
		// закрытие диалога
		hidePasswordModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showPasswordModal = false
			this.hideModalMask()
		},
		onFocusPassword() {
			// чистим ошибку если есть
			this.passwordField['_errMsg'] = ''
		},
		// непосредственное изменение пароля
		passwordChange() {
			// еще раз проверим доступ
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если есть ошибка
			if (this.passwordField['_errMsg'] !== '') return
			// пустой пароль нельзя
			if (this.passwordValue.trim().length === 0)
			{
				this.passwordField['_errMsg'] = 'validators/error_req'
				return
			}
			// все в порядке - начинаем менять пароль
			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'password': this.passwordValue.trim(),
							'reinstall': 0
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// закроем диалог
									this.hidePasswordModal()
									// установим успешное сообщение
									this.$emit('successMessage', 'service/password запущено...')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// ошибка по умолчанию
									this.passwordField['_errMsg'] = this.localeFtc('service/password_error')
									// если что то передали
									if (_dt['fields'] && _dt['fields']['password'])
									{
										if (Array.isArray(_dt['fields']['password']))
										{
											if (_dt['fields']['password'].length)
												this.passwordField['_errMsg'] = this.localeFtc(_dt['fields']['password'][0])
										}
										else
										{
											this.passwordField['_errMsg'] = this.localeFtc(_dt['fields']['password'])
										}
									}
									return
								}

								// закроем диалог
								this.hidePasswordModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроем диалог
								this.hidePasswordModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроем диалог
					this.hidePasswordModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроем диалог
					this.hidePasswordModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// диалог подтверждения
		//---------------------------------------------------------------------
		// закрытие диалога
		hideConfirmModal() {
			if (this.confirmModalTimerHandle)
			{
				clearInterval(this.confirmModalTimerHandle)
				this.confirmModalTimerHandle = false
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// резервирование IP
		//---------------------------------------------------------------------
		// старт процесса
		reserveIpStart() {
			// если еще активен таймер удаления
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// если нет ID текущего VDS
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если мы в процессе изменения - ничего не делаем
			if (this.reserveIpProcessing) return

			// ставим флаг начала процесса
			this.reserveIpProcessing = true
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'reserve_ip': this.reserveIpValue ? 0 : 1
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.reserveIpValue = !this.reserveIpValue
									// требуется рефреш
									setTimeout(() => {
										this.$emit('requestData')
									}, 1000)
									// а пока просто сообщим
									this.$emit('successMessage', 'main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// удаление VDS
		//---------------------------------------------------------------------
		// клик по кнопке в панеле (вызов диалога)
		deleteVds() {
			// если нет ID текущего VDS
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return

			// обнулим текущие данные
			this.reserveIpLocalData = null
			// запросим новые данные
			this.$emit('updateData')

			// чистим все сообщения
			this.localErrorMessage = ''

			// текст для диалога удаления
			this.deleteModalText = this.localeFtc('service/vds_delete_confirm').replace('{name}', this.serviceName)

			// таймер
			this.deleteModalTimer = 5
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true

			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// закрытие диалога
		hideDeleteModal() {
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		// старт удаления
		deleteStart() {
			// если еще активен таймер
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// если нет ID текущего VDS
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return

			// чистим все сообщения
			this.localErrorMessage = ''

			// закрываем диалога
			this.hideDeleteModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/delete/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// можно переходить в список VDS
									this.$router.push('/vds/list')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// ISO
		//---------------------------------------------------------------------
		hideOperISOModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showOperISOModal = false
			this.hideModalMask()
			this.onFocusIso()
		},
		// операция подключения или отключения образа (вызов диалога)
		async operIso() {
			// проверка допуска
			if (!this.Access || this.Status !== 'active' || this.isISOProcessActive) return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// обнулим старые значения
			this.isoOldValues = {}
			// предупреждение
			this.operisoModalText = this.localeFtc('service/iso_operation_warning')
			// кнопка
			this.operisoModalButton = 'main/save'

			// инициализируем списки в полях
			try {
				// делаем запрос свежих данных
				let res = await this.$http.get(this.APIServerUrl + '/service/update/' + this.vdsId)
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false

				if (_dt && _dt['status'] === 'form' && _dt['fields'] &&
					_dt['fields']['iso_id'] && _dt['fields']['iso_secondary_id'])
				{
					// инициализация списков, значений и заголовков
					this.makeISOListForField(_dt['fields'])
				}
			} catch (err) {}

			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showOperISOModal = true
		},
		// операция подключения или отключения образа
		operIsoBegin() {
			// проверка допуска
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''

			// id ISO
			let _id1 = null
			let _oldId1 = null
			let _id2 = null
			let _oldId2 = null
			let _successMessageEject = ''
			let _successMessageInsert = ''

			this.isoIdForPush1 = null
			this.isoIdForPush2 = null

			// если есть вставленные образы
			if (this.ISO && this.ISO.length)
			{
				if (this.isoOldValues.iso_id) {
					// старое значение первого поля
					_oldId1 = this.isoOldValues.iso_id

					// новое значение первого поля
					_id1 = this.isoValue1 == null || this.isoValue1 <= 0
						? 0
						: String(this.isoValue1) === String(this.isoOldValues.iso_id) ? null : this.isoValue1
				} else {
					// вставлено не было
					_oldId1 = null
					_id1 = this.isoValue1 == null || this.isoValue1 <= 0
						? null
						: this.isoValue1
				}

				if (this.isoOldValues.iso_secondary_id) {
					// старое значение второго поля
					_oldId2 = this.isoOldValues.iso_secondary_id

					// новое значение
					_id2 = this.isoValue2 == null || this.isoValue2 <= 0
						? 0
						: String(this.isoValue2) === String(this.isoOldValues.iso_secondary_id) ? null : this.isoValue2
				} else {
					// вставлено не было
					_oldId2 = null
					_id2 = this.isoValue2 == null || this.isoValue2 <= 0
						? null
						: this.isoValue2
				}

				// одинаковыми не могут быть
				let _resultSame = false
				// 1. случай - было вставлено в первый, а во втором пусто (1, 0)
				if (_oldId1 !== null && _oldId2 === null) {
					// а теперь еще вставили второй
					if (_id2 > 0)
					{
						_resultSame = String(_oldId1) === String(_id2)
					}
					// поменяли первый и вставили второй
					else if (_id1 > 0 && _id2 > 0)
					{
						_resultSame = String(_id1) === String(_id2)
					}
				}
				// 2. случай - было вставлено во второй, а в первом было пусто (0, 1)
				if (_oldId1 === null && _oldId2 !== null) {
					// а теперь еще вставили первый
					if (_id1 > 0)
					{
						_resultSame = String(_id1) === String(_oldId2)
					}
					// поменяли второй и вставили первый
					else if (_id1 > 0 && _id2 > 0)
					{
						_resultSame = String(_id1) === String(_id2)
					}
				}
				// 3. случай - было вставлено в оба (1, 1)
				if (_oldId1 !== null && _oldId2 !== null) {
					// а теперь поменяли какой то из дисков
					if (_id1 > 0)
					{
						_resultSame = String(_id1) === String(_oldId2) || String(_id1) === String(_id2)
					}
					// поменяли второй и вставили первый
					else if (_id2 > 0)
					{
						_resultSame = String(_id1) === String(_id2) || String(_oldId1) === String(_id2)
					}
				}

				if (_resultSame) {
					if (_id2 !== null && _id2 > 0) {
						this.isoField2['_errMsg'] = 'service/service_iso_same_error'
					} else {
						this.isoField1['_errMsg'] = 'service/service_iso_same_error'
					}

					return
				}
			}
			// это вставка
			else
			{
				// если первый диск не выбран
				if (!this.isoValue1 || this.isoValue1 < 0)
				{
					this.isoField1['_errMsg'] = 'error/required_field'
					return
				}

				// если вообще ничего не выбрано
				if ((!this.isoValue1 && !this.isoValue2) || (this.isoValue1 <= 0 && this.isoValue2 <= 0))
				{
					this.isoField1['_errMsg'] = 'error/required_field'
					return
				}

				// получим значения
				if (this.isoValue1 !== null && this.isoValue1 > 0) _id1 = this.isoValue1
				if (this.isoValue2 !== null && this.isoValue2 > 0) _id2 = this.isoValue2

				// одинаковыми не могут быть
				if (_id1 !== 0 || _id2 !== 0) {
					if ((_id1 !== null || _id2 !== null) && _id1 === _id2) {
						if (_id2 !== null && _id2 > 0) {
							this.isoField2['_errMsg'] = 'service/service_iso_same_error'
						} else {
							this.isoField1['_errMsg'] = 'service/service_iso_same_error'
						}

						return
					}
				}
			}

			// запоминаем для отслеживания в пушах
			this.isoIdForPush1 = _id1
			this.isoIdForPush2 = _id2

			// сообщение
			if (_id1 === 0 || _id2 === 0) {
				_successMessageEject = 'service/iso_ejecting_begin_process'
			}
			if (_id1 > 0 || _id2 > 0) {
				_successMessageInsert = 'service/iso_inserting_begin_process'
			}

			// закрываем диалог
			this.hideOperISOModal()

			// если так и нет новых значений
			if (_id1 === null && _id2 === null) {
				// ничего не делаем
				return
			}

			// проверка на старые значение
			if ('iso_id' in this.isoOldValues && String(this.isoOldValues.iso_id) === String(_id1) &&
				'iso_secondary_id' in this.isoOldValues && String(this.isoOldValues.iso_secondary_id) === String(_id2)) {
				// ничего не делаем
				return
			}

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'reinstall': 0
						}

						if (_id1 !== null && _id1 >= 0) _post[_dt['model']]['iso_id'] = _id1
						if (_id2 !== null && _id2 >= 0) _post[_dt['model']]['iso_secondary_id'] = _id2

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									if (_successMessageEject) {
										this.$emit('successMessage', _successMessageEject)
									}
									if (_successMessageInsert) {
										this.$emit('successMessage', _successMessageInsert)
									}
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// если что то передали
									if (_dt['fields'] && _dt['fields']['iso_id'])
									{
										if (Array.isArray(_dt['fields']['iso_id']))
										{
											if (_dt['fields']['iso_id'].length)
												this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'][0])
										}
										else
										{
											this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'])
										}
									}
									if (_dt['fields'] && _dt['fields']['iso_secondary_id'])
									{
										if (Array.isArray(_dt['fields']['iso_secondary_id']))
										{
											if (_dt['fields']['iso_secondary_id'].length)
												this.localErrorMessage = this.localeFtc(_dt['fields']['iso_secondary_id'][0])
										}
										else
										{
											this.localErrorMessage = this.localeFtc(_dt['fields']['iso_secondary_id'])
										}
									}
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// обнуление ошибки при фокусе на поле выбора ISO
		//---------------------------------------------------------------------
		onFocusIso() {
			this.isoField1['_errMsg'] = ''
			this.isoField2['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// формирование списка ISO
		//---------------------------------------------------------------------
		makeISOListForField(isoFields) {
			if (!isoFields) return

			// первое поле
			let isoField = isoFields['iso_id']

			// если есть вставленное значение
			if (isoField && isoField.title) {
				// заголовок как есть
				this.isoField1.title = isoField.title

				// значение
				if ('value' in isoField &&
					isoField.value !== null &&
					isoField.value > 0) {
					// уже есть вставленное значение
					// список как есть
					this.isoField1.list = isoField.list && isoField.list.length
						? isoField.list
						: []

					// ищем в списке вставленных
					let _idx = -1
					if (this.ISO && this.ISO.length) {
						this.ISO.some((i, x) => {
							if (i && i['service_id'] && String(i['service_id']['value']) === String(isoField.value)) {
								_idx = x
								return true
							}
						})
					}

					// если нашли
					if (_idx >= 0) {
						this.isoOldValues.iso_id = this.ISO[_idx]['service_id']['value']
						this.$set(this, 'isoValue1', this.ISO[_idx]['service_id']['value'])
						this.$nextTick(() => {
							EventBus.$emit('w5-set-list-field-value', {
								name: 'iso_id1',
								value: {
									id: this.ISO[_idx]['service_id']['value'],
									name: this.ISO[_idx]['service_name']['value']
								}
							})
						})
					}
				} else {
					// вставленного значения нет
					// список ставим общий
					this.isoField1.list = [{ id: -1, name: 'main/not_chosen' }].concat(
						isoField.list && isoField.list.length
							? isoField.list
							: []
					)

					// значение - "не выбрано"
					this.isoOldValues.iso_id = -1
					this.$set(this, 'isoValue1', -1)
					this.$nextTick(() => {
						EventBus.$emit('w5-set-list-field-value', {
							name: 'iso_id1',
							value: {
								id: -1,
								name: this.localeFtc('main/not_chosen')
							}
						})
					})
				}
			}

			// второе поле
			isoField = isoFields['iso_secondary_id']

			// если есть вставленное значение
			if (isoField && isoField.title) {
				// заголовок как есть
				this.isoField2.title = isoField.title

				// значение
				if ('value' in isoField &&
					isoField.value !== null &&
					isoField.value > 0) {
					// уже есть вставленное значение
					// список как есть
					this.isoField2.list = isoField.list && isoField.list.length
						? isoField.list
						: []

					// ищем в списке вставленных
					let _idx = -1
					if (this.ISO && this.ISO.length) {
						this.ISO.some((i, x) => {
							if (i && i['service_id'] && String(i['service_id']['value']) === String(isoField.value)) {
								_idx = x
								return true
							}
						})
					}

					// если нашли
					if (_idx >= 0) {
						this.isoOldValues.iso_secondary_id = this.ISO[_idx]['service_id']['value']
						this.$set(this, 'isoValue2', this.ISO[_idx]['service_id']['value'])
						this.$nextTick(() => {
							EventBus.$emit('w5-set-list-field-value', {
								name: 'iso_id2',
								value: {
									id: this.ISO[_idx]['service_id']['value'],
									name: this.ISO[_idx]['service_name']['value']
								}
							})
						})
					}
				} else {
					// вставленного значения нет
					// список ставим общий
					this.isoField2.list = [{ id: -1, name: 'main/not_chosen' }].concat(
						isoField.list && isoField.list.length
							? isoField.list
							: []
					)

					// значение - "не выбрано"
					this.isoOldValues.iso_secondary_id = -1
					this.$set(this, 'isoValue2', -1)
					this.$nextTick(() => {
						EventBus.$emit('w5-set-list-field-value', {
							name: 'iso_id2',
							value: {
								id: -1,
								name: this.localeFtc('main/not_chosen')
							}
						})
					})
				}
			}
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'access': function(access) {
			this.Access = access
		},
		'status': function(status) {
			this.Status = status
		},
		'canReboot': function(canReboot) {
			this.Reboot = canReboot
		},
		'templateName': function(templateName) {
			this.Template = templateName
			// если название шаблона не содержит "windows" и "freebsd" - добавим предупреждение о перезагрузке
			/*
			if (this.Template.toLowerCase().indexOf('windows') < 0 ||
				this.Template.toLowerCase().indexOf('freebsd') < 0)
			*/
			// теперь это нужно показывать в любом случае
			this.passwordWarning = this.localeFtc('service/reboot_warning')

			// описание смены пароля
			this.rebootWarning = 'service/change_password_for_vnc'
			// для линуксов еще и пароль рута
			if (this.Template.toLowerCase().indexOf('centos') >= 0 ||
				this.Template.toLowerCase().indexOf('ubuntu') >= 0 ||
				this.Template.toLowerCase().indexOf('debian') >= 0)
				this.rebootWarning = 'service/change_password_for_vnc_linux'
		},
		'serviceFullName': function(serviceFullName) {
			this.fullName = serviceFullName
		},
		'iso': function(iso) {
			this.ISO = iso
		},
		'serviceProlong': function(value) {
			this.autoProlongValue = value
		},
		'serviceCanProlong': function(value) {
			this.canProlong = value
		},
		'serviceCanDelete': function(value) {
			this.canDelete = value
		},
		'parentError': function(value) {
			this.Error = value
		},
		'reserveIpData': function(data) {
			this.reserveIpLocalData = data
			this.reserveIpValue = data && 'value' in data
				? data.value
				: false
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field,
		urlButtonComponent
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.tab-pane-command-wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: space-between;		
	-webkit-justify-content: space-between;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;

	flex-direction: column;

	margin: 15px 0;
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 4px;
}

.tab-pane-command-wrapper > h4 {
	padding: 0;
	margin: 0;
	font-weight: 400;
	margin-bottom: 10px;
}

.tab-command-button {
	height: 46px !important;
	width: 200px;
	font-weight: 300 !important;
	line-height: 46px !important;
}

.tab-command-button > svg.svg-inline--fa {
	margin-right: 10px;
}

.other-panels {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: space-between;		
	-webkit-justify-content: space-between;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	align-items: center;
}

/* блок кнопки удаления */
.del-button-wrapper {
	padding: 0;
	width: 100%;
}

.del-button-wrapper .btn {
	font-weight: 400 !important;
	background-color: transparent !important;
	color: #d43f3a !important;
	text-shadow: none !important;
}

.del-button-wrapper .btn:hover {
	color: white !important;
	background: #f9302c !important;
}

.warning-message {
	font-weight: normal;
	color: #666;
	padding: 0;	
}

/* блок автопролонгации */
.autoprolong-wrapper {
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 4px;
	width: 49%;
	min-height: 162px;
}

@media (max-width: 767px) {
	.tab-pane-command-wrapper {
		flex-direction: row;		
	}
	.tab-pane-command-wrapper > h4, .tab-pane-command-wrapper > p {
		font-size: 85%;
	}
	.tab-command-button {		
		height: 40px !important;
		line-height: 40px !important;
	}

	.other-panels {
		flex-direction: column;
	}

	.del-button-wrapper {
		width: 100%;
		min-height: auto;
	}
		
	.autoprolong-wrapper {		
		width: 100%;
		min-height: auto;
	}

	.warning-message {
		font-size: 85%;
	}
}

@media (min-width: 768px) and (max-width: 900px) {
	.del-button-wrapper,
	.autoprolong-wrapper {
		min-height: 180px;
	}
}

.modal-footer.flbx {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;
	flex-direction: row;
}
.modal-footer.flbx::after,
.modal-footer.flbx::before {
	display: none;
}
.modal-footer.flbx.r {
	align-items: flex-end;
	-webkit-align-items: flex-end;
	flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// command.vue?b92efc48